module.exports = __webpack_public_path__ + "img/sopra_le_dita_dx.9f83ca6c.png";